import { Component } from "react";

export default class ConditionalSatement extends Component {
  render() {
    const value = this.props.params.value;
    return <div>{value}</div>;
  }
}
